import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './footer-over-ons.css'

const FooterOverOns = (props) => {
  return (
    <div className="footer-over-ons-container1">
      <Helmet>
        <title>FooterOver-Ons - Idensite</title>
        <meta
          property="og:title"
          content="FooterOver-Ons - Idensite"
        />
        <link
          rel="canonical"
          href="https://quizzical-fixed-beaver-a4asmg.teleporthq.site/footer-over-ons"
        />
        <meta
          property="og:url"
          content="https://quizzical-fixed-beaver-a4asmg.teleporthq.site/footer-over-ons"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="about-section">
        <div className="about-container">
          <div className="about-grid">
            <div className="about-column">
              <h2 className="section-title">Onze Missie</h2>
              <p className="section-content">
                Idensite is ontstaan uit een passie voor vakmanschap en digitale
                helderheid. Wij geloven dat elke Belgische vakman een online
                visitekaartje verdient dat even degelijk is als zijn eigen werk.
              </p>
            </div>
            <div className="about-column">
              <h2 className="section-title">Onze Doelgroep</h2>
              <p className="section-content">
                Wij focussen ons specifiek op vakmannen in België. Of je nu
                loodgieter, schrijnwerker of elektricien bent, wij spreken jouw
                taal en begrijpen wat jouw klanten zoeken in een website.
              </p>
            </div>
            <div className="about-column">
              <h2 className="section-title">Onze Kernwaarden</h2>
              <p className="section-content">
                Duidelijkheid, betrouwbaarheid en snelheid vormen de fundering
                van Idensite. Geen complexe praat, maar een website die werkt,
                snel online is en precies doet wat nodig is.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-quick-section">
        <div className="contact-container">
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="contact-label">E-mail ons</h3>
              <a href="mailto:contact@idensite.be?subject=">
                <div className="contact-link">
                  <span>contact@idensite.be</span>
                </div>
              </a>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="contact-label">Bel ons</h3>
              <span className="contact-text">+32 00 000 00 00</span>
            </div>
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle r="4" cx="12" cy="7"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="contact-label">Uw noden</h3>
              <p className="contact-text">
                <span>
                  {' '}
                  Mail ons uw noden voor een voorstel op maat of vul het
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <a href="#contact">
                  <div className="footer-over-ons-thq-inline-link-elm">
                    <span>formulier</span>
                  </div>
                </a>
                <span>
                  {' '}
                  in.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="legal-bar-section">
        <div className="legal-container">
          <div className="legal-brand">
            <span className="legal-logo">Idensite</span>
          </div>
          <div className="legal-links">
            <a href="#">
              <div className="legal-link">
                <span>Privacybeleid</span>
              </div>
            </a>
            <a href="#">
              <div className="legal-link">
                <span>Algemene Voorwaarden</span>
              </div>
            </a>
            <a href="#">
              <div className="legal-link">
                <span>Cookieverklaring</span>
              </div>
            </a>
          </div>
          <div className="legal-disclaimer">
            <p className="legal-text">
              Wij gebruiken uw gegevens enkel voor direct contact en
              serviceoptimalisatie.
            </p>
          </div>
        </div>
      </section>
      <section className="cta-email-section">
        <div className="cta-container">
          <div className="cta-card">
            <div className="cta-content">
              <h2 className="section-title">Klaar om te starten?</h2>
              <p className="section-content">
                Geniet van een snelle oplevering en heldere afspraken voor uw
                nieuwe website.
              </p>
            </div>
            <div className="cta-action">
              <a href="mailto:contact@idensite.be?subject=">
                <div className="btn-lg btn-primary btn">
                  <span>Stuur een e-mail</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-rules-section">
        <div className="trust-container">
          <div className="trust-grid">
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="trust-title">Duidelijke afspraken</h3>
              <p className="section-content">
                Geen verrassingen achteraf. We bespreken alles vooraf tot in de
                details.
              </p>
            </div>
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="trust-title">30% voorschot, 70% bij oplevering</h3>
              <p className="section-content">
                U betaalt pas het grootste deel wanneer u volledig tevreden bent
                met het resultaat.
              </p>
            </div>
            <div className="trust-card">
              <div className="trust-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973"></path>
                    <path d="m13 12l-3 5h4l-3 5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="trust-title">
                Mobile-first &amp; snelle laadtijd
              </h3>
              <p className="section-content">
                Uw website werkt perfect op elk toestel en laadt razendsnel voor
                uw bezoekers.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-over-ons-container2">
        <div className="footer-over-ons-container3">
          <Script
            html={`<script defer data-name="idensite-footer-interactions">
(function(){
  const trustCards = document.querySelectorAll(".trust-card")

  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const trustObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }, index * 150)
        trustObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)

  trustCards.forEach((card) => {
    card.style.opacity = "0"
    card.style.transform = "translateY(20px)"
    card.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"
    trustObserver.observe(card)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default FooterOverOns
